"use client";
import { c as P, f as x, e as k } from "./element-DE7VsBMX.mjs";
import * as b from "react";
import { u as L } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { b as V } from "./detectBrowser-CpuomNQW.mjs";
import { v as q } from "./visuallyHidden-DPuANzJJ.mjs";
import { j as B } from "./jsx-runtime-CJ-St4mQ.mjs";
import { a as U } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as j } from "./useEventCallback-CjuAhyNz.mjs";
import { u as G } from "./useId-CFOlRH4L.mjs";
import { c as z, a as W } from "./FloatingTree-vWe5pGqE.mjs";
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Z = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], g = /* @__PURE__ */ Z.join(","), E = typeof Element > "u", v = E ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, p = !E && Element.prototype.getRootNode ? function(a) {
  var e;
  return a == null || (e = a.getRootNode) === null || e === void 0 ? void 0 : e.call(a);
} : function(a) {
  return a == null ? void 0 : a.ownerDocument;
}, m = function a(e, t) {
  var r;
  t === void 0 && (t = !0);
  var i = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), s = i === "" || i === "true", n = s || t && e && a(e.parentNode);
  return n;
}, X = function(e) {
  var t, r = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return r === "" || r === "true";
}, w = function(e, t, r) {
  if (m(e))
    return [];
  var i = Array.prototype.slice.apply(e.querySelectorAll(g));
  return t && v.call(e, g) && i.unshift(e), i = i.filter(r), i;
}, N = function a(e, t, r) {
  for (var i = [], s = Array.from(e); s.length; ) {
    var n = s.shift();
    if (!m(n, !1))
      if (n.tagName === "SLOT") {
        var o = n.assignedElements(), u = o.length ? o : n.children, l = a(u, !0, r);
        r.flatten ? i.push.apply(i, l) : i.push({
          scopeParent: n,
          candidates: l
        });
      } else {
        var f = v.call(n, g);
        f && r.filter(n) && (t || !e.includes(n)) && i.push(n);
        var c = n.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(n), h = !m(c, !1) && (!r.shadowRootFilter || r.shadowRootFilter(n));
        if (c && h) {
          var d = a(c === !0 ? n.children : c.children, !0, r);
          r.flatten ? i.push.apply(i, d) : i.push({
            scopeParent: n,
            candidates: d
          });
        } else
          s.unshift.apply(s, n.children);
      }
  }
  return i;
}, A = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, C = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || X(e)) && !A(e) ? 0 : e.tabIndex;
}, Y = function(e, t) {
  var r = C(e);
  return r < 0 && t && !A(e) ? 0 : r;
}, $ = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, O = function(e) {
  return e.tagName === "INPUT";
}, J = function(e) {
  return O(e) && e.type === "hidden";
}, K = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return t;
}, Q = function(e, t) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === t)
      return e[r];
}, H = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || p(e), r = function(o) {
    return t.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(e.name));
  else
    try {
      i = r(e.name);
    } catch (n) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", n.message), !1;
    }
  var s = Q(i, e.form);
  return !s || s === e;
}, _ = function(e) {
  return O(e) && e.type === "radio";
}, ee = function(e) {
  return _(e) && !H(e);
}, te = function(e) {
  var t, r = e && p(e), i = (t = r) === null || t === void 0 ? void 0 : t.host, s = !1;
  if (r && r !== e) {
    var n, o, u;
    for (s = !!((n = i) !== null && n !== void 0 && (o = n.ownerDocument) !== null && o !== void 0 && o.contains(i) || e != null && (u = e.ownerDocument) !== null && u !== void 0 && u.contains(e)); !s && i; ) {
      var l, f, c;
      r = p(i), i = (l = r) === null || l === void 0 ? void 0 : l.host, s = !!((f = i) !== null && f !== void 0 && (c = f.ownerDocument) !== null && c !== void 0 && c.contains(i));
    }
  }
  return s;
}, T = function(e) {
  var t = e.getBoundingClientRect(), r = t.width, i = t.height;
  return r === 0 && i === 0;
}, re = function(e, t) {
  var r = t.displayCheck, i = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var s = v.call(e, "details>summary:first-of-type"), n = s ? e.parentElement : e;
  if (v.call(n, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var o = e; e; ) {
        var u = e.parentElement, l = p(e);
        if (u && !u.shadowRoot && i(u) === !0)
          return T(e);
        e.assignedSlot ? e = e.assignedSlot : !u && l !== e.ownerDocument ? e = l.host : e = u;
      }
      e = o;
    }
    if (te(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return T(e);
  return !1;
}, ae = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var r = 0; r < t.children.length; r++) {
          var i = t.children.item(r);
          if (i.tagName === "LEGEND")
            return v.call(t, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, S = function(e, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  m(t) || J(t) || re(t, e) || // For a details element with a summary, the summary element gets the focus
  K(t) || ae(t));
}, I = function(e, t) {
  return !(ee(t) || C(t) < 0 || !S(e, t));
}, ie = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, ne = function a(e) {
  var t = [], r = [];
  return e.forEach(function(i, s) {
    var n = !!i.scopeParent, o = n ? i.scopeParent : i, u = Y(o, n), l = n ? a(i.candidates) : o;
    u === 0 ? n ? t.push.apply(t, l) : t.push(o) : r.push({
      documentOrder: s,
      tabIndex: u,
      item: i,
      isScope: n,
      content: l
    });
  }), r.sort($).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(t);
}, F = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = N([e], t.includeContainer, {
    filter: I.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: ie
  }) : r = w(e, t.includeContainer, I.bind(null, t)), ne(r);
}, ge = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = N([e], t.includeContainer, {
    filter: S.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : r = w(e, t.includeContainer, S.bind(null, t)), r;
}, pe = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return v.call(e, g) === !1 ? !1 : I(t, e);
};
const D = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function M(a, e) {
  const t = F(a, D()), r = t.length;
  if (r === 0)
    return;
  const i = k(x(a)), s = t.indexOf(i), n = s === -1 ? e === 1 ? 0 : r - 1 : s + e;
  return t[n];
}
function me(a) {
  return M(x(a).body, 1) || a;
}
function ye(a) {
  return M(x(a).body, -1) || a;
}
function Se(a, e) {
  const t = e || a.currentTarget, r = a.relatedTarget;
  return !r || !P(t, r);
}
function Ie(a) {
  F(a, D()).forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  });
}
function xe(a) {
  a.querySelectorAll("[data-tabindex]").forEach((t) => {
    const r = t.dataset.tabindex;
    delete t.dataset.tabindex, r ? t.setAttribute("tabindex", r) : t.removeAttribute("tabindex");
  });
}
function Re(a) {
  return `data-base-ui-${a}`;
}
const se = /* @__PURE__ */ b.forwardRef(function(e, t) {
  const [r, i] = b.useState();
  L(() => {
    V && i("button");
  }, []);
  const s = {
    ref: t,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    style: q
  };
  return /* @__PURE__ */ B.jsx("span", {
    ...e,
    ...s,
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (se.displayName = "FocusGuard");
function Te(a) {
  const {
    open: e = !1,
    onOpenChange: t,
    elements: r
  } = a, i = G(), s = b.useRef({}), [n] = b.useState(() => z()), o = W() != null;
  if (process.env.NODE_ENV !== "production") {
    const d = r.reference;
    d && !U(d) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [u, l] = b.useState(r.reference), f = j((d, y, R) => {
    s.current.openEvent = d ? y : void 0, n.emit("openchange", {
      open: d,
      event: y,
      reason: R,
      nested: o
    }), t == null || t(d, y, R);
  }), c = b.useMemo(() => ({
    setPositionReference: l
  }), []), h = b.useMemo(() => ({
    reference: u || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [u, r.reference, r.floating]);
  return b.useMemo(() => ({
    dataRef: s,
    open: e,
    onOpenChange: f,
    elements: h,
    events: n,
    floatingId: i,
    refs: c
  }), [e, f, h, n, i, c]);
}
export {
  se as F,
  me as a,
  pe as b,
  Re as c,
  Ie as d,
  xe as e,
  D as f,
  ye as g,
  ge as h,
  Se as i,
  F as t,
  Te as u
};
